import React, { useEffect, useContext, useState } from 'react';
import {Row, Col } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import { ChartsGoogle } from './ChartsGoogle';
import { BarChartsGoogle } from './BarChartsGoogle';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { fetchAuthSession } from 'aws-amplify/auth';

const config = require('../../config.json');


export default function IssueReport(props) {
  // Modern styles for IssueReport
  const issueReportModernStyles = `
    .issue-report-bg {
      background: linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%);
      min-height: 100vh;
      padding: 0;
      font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
    }
    .issue-report-title {
      font-size: 2rem;
      font-weight: 800;
      color: #1a2a4f;
      margin-bottom: 1.2rem;
      letter-spacing: 0.5px;
      text-align: center;
      text-shadow: 0 2px 8px rgba(44,62,80,0.07);
    }
    .issue-report-stats-row {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 1.5rem;
      margin-bottom: 2rem;
    }
    .issue-report-stat-card {
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.10);
      padding: 1.2rem 1.5rem;
      min-width: 180px;
      max-width: 260px;
      flex: 1 1 180px;
      display: flex;
      flex-direction: column;
      align-items: center;
      transition: box-shadow 0.2s, transform 0.2s;
      border: 1.5px solid #e3eafc;
    }
    .issue-report-stat-card:hover {
      box-shadow: 0 8px 32px 0 rgba(44, 62, 80, 0.16);
      transform: translateY(-4px) scale(1.03);
      border: 1.5px solid #4f8cff;
    }
    .issue-report-stat-img {
      width: 48px;
      height: 48px;
      margin-bottom: 0.7rem;
      object-fit: contain;
      filter: drop-shadow(0 2px 8px rgba(44,62,80,0.07));
    }
    .issue-report-stat-value {
      font-size: 2.1rem;
      font-weight: 700;
      color: #4f8cff;
      margin-bottom: 0.2rem;
      text-align: center;
    }
    .issue-report-stat-label {
      font-size: 1.08rem;
      color: #2a3659;
      font-weight: 500;
      text-align: center;
      letter-spacing: 0.2px;
    }
    @media (max-width: 900px) {
      .issue-report-title {
        font-size: 1.3rem;
      }
      .issue-report-stat-card {
        min-width: 120px;
        padding: 0.8rem 0.7rem;
      }
      .issue-report-stat-value {
        font-size: 1.3rem;
      }
    }
    @media (max-width: 700px) {
      .issue-report-stats-row {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
      }
      .issue-report-stat-card {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: 0 auto;
      }
    }
    @media (max-width: 600px) {
      .issue-report-title {
        font-size: 1.08rem;
        margin-bottom: 0.7rem;
      }
      .issue-report-stats-row {
        gap: 0.7rem;
      }
      .issue-report-stat-card {
        min-width: 90px;
        padding: 0.5rem 0.3rem;
      }
      .issue-report-stat-value {
        font-size: 1.1rem;
      }
      .issue-report-stat-label {
        font-size: 0.95rem;
      }
    }
    @media (max-width: 400px) {
      .issue-report-title {
        font-size: 0.95rem;
      }
      .issue-report-stat-card {
        padding: 0.3rem 0.1rem;
      }
    }
  `;
    const {setSearchTopic, setSearchValue, searchTopic, searchValue } = props;
    const { generateDate, generateReturnDate } = useContext(ProductContext);
    const [issueDetails, setIssueDetails] =useState({dueBooks : [], nextDueBooks:[]})
    const [regYearCount, setRegYearCount] = useState();
    const [googleIssueData, setGoogleIssueData]= useState();
    const [isIssueDayCount, setIsIssueDayCount]=useState(false);
    const [googleReturnData, setGoogleReturnData]= useState();
    const [isReturnDayCount, setIsReturnDayCount]=useState(false);
    const [googleUserData, setGoogleUserData]= useState();
    const [isUserDayCount, setIsUserDayCount]=useState(false);
    const [searchResult, setSearchResult]=useState([]);
    const [loaded, setLoaded] = useState(false);
    const { enqueueSnackbar } = useSnackbar();


    useEffect(()=>{
      handleIssueSearch();
      },[])

      const handleIssueSearch=async()=>{
        //event.preventDefault();
        //console.log("issue book : ");
        try{
            setLoaded(false);
            //setDispMsg('');
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const clientID="AKLibrary";
            //const searchValue = searchValue;
            //const searchTopic = searchTopic;
            await axios.get(`${config.api.invokeUrl}/reports/issue?clientID=${clientID}`, {
            headers: {
              Authorization: idToken,
             'x-api-key':config.api.key
            }
          }).then(async(response) => {
           //console.log("response : ", response.data);
           //setDispMsg(response.data.length+' - Books Found');
            if(response.data.length>0)
            {
                setSearchResult(response.data);
                  processIssueReports(response.data);
                  initializeValues(response.data);
            }
            enqueueSnackbar('Issue Report loaded successfully',{variant:'success'}); 
            setLoaded(true);
        }).catch((error)=>{
          enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
      })
        }catch(error){
            //console.log("error:", error);
            enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        }
    

    }

      const processIssueReports=async(tsearchResult)=>{
        const todayDate=await generateDate();
        const nextDueDate=await generateReturnDate(7);
        const dueBooks=tsearchResult.filter((item)=>item.bookedTo<todayDate);
        //console.log("Due books :", dueBooks);
        const nextSevenDays=tsearchResult.filter((item)=>item.bookedTo<nextDueDate & item.bookedTo>todayDate);
        //console.log("Next Due books :", nextSevenDays);
        setIssueDetails({...issueDetails,
            dueBooks:dueBooks, nextDueBooks:nextSevenDays
        });
        processIssueTrendData(tsearchResult);
        processReturnTrendData(tsearchResult);
        //processData(searchResult);
      }

      const processIssueTrendData=async(tsearchResult)=>{
        const dayIssueCount={};
        for(var i =-30; i<=0; i++ ){
            //console.log("i : ", i);
            const nextDueDate=await generateReturnDate(i);
            const dueBooks=tsearchResult.filter((item)=>item.bookedOn===nextDueDate); 
            const ttemp=nextDueDate.toString();
            dayIssueCount[ttemp]=dueBooks.length;   
        }
        //console.log("day issue count ", dayIssueCount);
        processData(dayIssueCount,"Issue");
      }

      const processData=(rawData, type)=>{
        var regChartHeader=[];
        var regChartValues=[];
        var chartHearder="";
        if(type==="Issue"){
            chartHearder=["Date","Book's Issued"];
        }else if(type==="User"){
            chartHearder=["User","Book's Count"];
        }else{
            chartHearder=["Date","Book's Return"];
        }
        regChartHeader.push(chartHearder);    
        for(const data in rawData){
            const ttt=[data, rawData[data]];
            regChartHeader.push(ttt);
           // regChartHeader.push(rawData[data]);

            regChartValues.push(rawData[data]);
        //    console.log(data," - ", rawData[data]);

        }
        const regChartData={};
        regChartData.labels=regChartHeader;
        regChartData.series=regChartValues;
        setRegYearCount(regChartData);
        //console.log("Data : ", regChartData);
        var tdata=[]
        tdata.push(chartHearder);
        tdata.push(regChartHeader);
        tdata.push(regChartValues);
        if(type==="Issue"){
            setGoogleIssueData(regChartHeader);
            setIsIssueDayCount(true);
        }else if(type==="User"){
            setGoogleUserData(regChartHeader);
            setIsUserDayCount(true);
        }else {
            setGoogleReturnData(regChartHeader);
            setIsReturnDayCount(true);
        }
    }

    const processReturnTrendData=async(tsearchResult)=>{
        const dayIssueCount={};
        for(var i =0; i<=30; i++ ){
            //console.log("i : ", i);
            const nextDueDate=await generateReturnDate(i);
            const dueBooks=tsearchResult.filter((item)=>item.bookedTo===nextDueDate); 
            const ttemp=nextDueDate.toString();
            dayIssueCount[ttemp]=dueBooks.length;   
        }
        //console.log("day issue count ", dayIssueCount);
        processData(dayIssueCount, "Return");
      }

      const initializeValues=(tsearchResult)=>{
        var uniqueArray = removeDuplicates("bookedfor", tsearchResult);
        var sortedArray = uniqueArray.sort((a, b) => {return a.bookedfor - b.bookedfor;});
        //setCoursesAvailable(sortedcourseArray);
        //console.log("Courses Name : ", sortedArray);
        processUserTrendData(sortedArray, tsearchResult);
      }
    
      const removeDuplicates=(tprop, tsearchResult)=> {
        var newArray = [];
        var lookupObject  = {};
        for(var i in tsearchResult) {
           lookupObject[tsearchResult[i][tprop]] = tsearchResult[i];
        }
    
        for(i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
         return newArray;
    }

    const processUserTrendData=async(sortedArray, tsearchResult)=>{
        const dayIssueCount={};
        for(const i in sortedArray ){
            //console.log("i : ", i);
            const nextDueDate=await generateReturnDate(i);
            const dueBooks=tsearchResult.filter((item)=>item.bookedfor===sortedArray[i].bookedfor); 
            const ttemp=sortedArray[i].bookedfor;
            dayIssueCount[ttemp]=dueBooks.length;   
        }
        //console.log("day issue count ", dayIssueCount);
        //var sortedArray = uniqueArray.sort((a, b) => {return a.bookedfor - b.bookedfor;});
        processData(dayIssueCount,"User");
      }



  return (
    <div className="issue-report-bg">
      <style>{issueReportModernStyles}</style>
      <section style={{paddingTop: '24px', paddingBottom: '24px'}}>
        <div className="issue-report-title">Issue Report</div>
        <div className="issue-report-stats-row">
          <div className="issue-report-stat-card">
            <img className="issue-report-stat-img" src="images/cat1.png" alt="Books Issued" />
            <div className="issue-report-stat-value">{searchResult.length}</div>
            <div className="issue-report-stat-label">Books Issued</div>
          </div>
          <div className="issue-report-stat-card">
            <img className="issue-report-stat-img" src="images/cat1.png" alt="Books Over Due" />
            <div className="issue-report-stat-value">{issueDetails.dueBooks.length}</div>
            <div className="issue-report-stat-label">Books Over Due</div>
          </div>
          <div className="issue-report-stat-card">
            <img className="issue-report-stat-img" src="images/cat1.png" alt="Due in next 7 days" />
            <div className="issue-report-stat-value">{issueDetails.nextDueBooks.length}</div>
            <div className="issue-report-stat-label">Due in next 7 days</div>
          </div>
        </div>
        <div className='p-3'>
          {isIssueDayCount?
            <Row className="justify-content-md-center">
              <Col xs={12} className="mb-4 d-none d-sm-block">
                <ChartsGoogle regYearCount={googleIssueData} titleMsg="Last 30 day's - Book's Issued Count"/>
              </Col>
            </Row>:null}
          {isReturnDayCount?
            <Row className="justify-content-md-center">
              <Col xs={12} className="mb-4 d-none d-sm-block">
                <ChartsGoogle regYearCount={googleReturnData} titleMsg="30 day's - Book's Return Count"/>
              </Col>
            </Row>:null}
          {isUserDayCount?
            <Row className="justify-content-md-center">
              <Col xs={12} className="mb-4 d-none d-sm-block">
                <BarChartsGoogle regYearCount={googleUserData} titleMsg="User Pattern"/>
              </Col>
            </Row>:null}
        </div>
      </section>
    </div>
  )
}
